<div class="informacoes-colunas">
  <div class="informacoes-secoes">
    <p class="informacoes-estado" role="status" aria-live="polite">
      @if (cartaCarregando()) {
        Carregando as informações do serviço...
      }
    </p>

    @if (cartaFalhou()) {
      <div class="informacoes-aviso" role="alert">
        <p>Não foi possível carregar as informações deste serviço agora. Tente novamente em instantes.</p>
        <button type="button" class="informacoes-aviso-botao" (click)="recarregarCarta.emit()">
          Tentar novamente
        </button>
      </div>
    } @else if (cartaVazia()) {
      <p class="informacoes-aviso">
        As informações detalhadas deste serviço ainda não foram publicadas pelo órgão responsável.
      </p>
    }

    @if (orgaos().length > 0) {
      <p class="informacoes-orgaos">
        <i-lucide name="building-2" size="16" aria-hidden="true"></i-lucide>
        <span>{{ orgaos().join('; ') }}</span>
      </p>
    }

    @for (secao of secoes(); track secao.id) {
      <section class="informacoes-secao" [attr.data-aberta]="secaoAberta() === secao.id">
        <h2 class="informacoes-secao-cabecalho">
          <button
            type="button"
            class="informacoes-secao-botao"
            [attr.aria-expanded]="secaoAberta() === secao.id"
            [attr.aria-controls]="'informacoes-painel-' + secao.id"
            (click)="alternarSecao(secao.id)"
          >
            <span class="informacoes-secao-titulo">
              <i-lucide [name]="secao.icone" size="16" aria-hidden="true"></i-lucide>
              {{ secao.titulo }}
            </span>

            <i-lucide
              class="informacoes-secao-seta"
              [name]="secaoAberta() === secao.id ? 'chevron-up' : 'chevron-down'"
              size="18"
              aria-hidden="true"
            ></i-lucide>
          </button>
        </h2>

        @if (secaoAberta() === secao.id) {
          <div class="informacoes-secao-painel" [id]="'informacoes-painel-' + secao.id">
            @if (secao.html) {
              <!--
                HTML do editor do adm: listas e passo a passo perderiam o sentido como texto
                corrido. Passa pela sanitização padrão do Angular — sem bypassSecurityTrust.
              -->
              <div class="informacoes-secao-texto" [innerHTML]="secao.conteudo"></div>
            } @else {
              <p class="informacoes-secao-texto">{{ secao.conteudo }}</p>
            }
          </div>
        }
      </section>
    }

    @if (criadoEm() || atualizadoEm()) {
      <p class="informacoes-datas">
        @if (criadoEm()) {
          <span>Publicado em: {{ criadoEm() }}</span>
        }
        @if (atualizadoEm()) {
          <span>Atualizado em: {{ atualizadoEm() }}</span>
        }
      </p>
    }
  </div>

  <aside class="informacoes-login" aria-labelledby="informacoes-login-titulo" #cartaoLogin>
    <div class="informacoes-login-topo">
      <span class="informacoes-login-avatar" aria-hidden="true">
        <i-lucide name="users" size="20"></i-lucide>
      </span>

      <h2 class="informacoes-login-titulo" id="informacoes-login-titulo">
        @if (logado()) {
          Olá, {{ nomeUsuario() }}
        } @else {
          Acesse para abrir<br />sua solicitação
        }
      </h2>
    </div>

    @if (logado()) {
      <p class="informacoes-login-texto">
        Você já está autenticado. Continue para preencher sua solicitação.
      </p>

      <button type="button" class="informacoes-login-botao informacoes-login-botao-primario" (click)="solicitar.emit()">
        <i-lucide name="arrow-right" size="16" aria-hidden="true"></i-lucide>
        Continuar solicitação
      </button>

      <button type="button" class="informacoes-login-botao informacoes-login-botao-anonimo" (click)="sair()">
        <i-lucide name="log-out" size="16" aria-hidden="true"></i-lucide>
        Sair
      </button>
    } @else {
    <p class="informacoes-login-etiqueta">Utilize a carta de serviços</p>
    <p class="informacoes-login-texto">Para realizar sua solicitação, faça o login ou solicite anonimamente.</p>

    <form class="informacoes-login-formulario" novalidate (submit)="entrar($event)">
      <label class="informacoes-login-rotulo" for="informacoes-login-documento">CPF / CNPJ</label>
      <input
        id="informacoes-login-documento"
        #campoDocumento
        class="informacoes-login-campo"
        type="text"
        inputmode="numeric"
        autocomplete="username"
        placeholder="000.000.000-00"
        [mask]="mascaraDocumento"
        [attr.aria-invalid]="tentouEntrar() && !documentoValido()"
        [attr.aria-describedby]="tentouEntrar() && !documentoValido() ? 'informacoes-login-documento-erro' : null"
        [formField]="loginForm.documento"
      />
      @if (tentouEntrar() && !documentoValido()) {
        <p class="informacoes-login-erro-campo" id="informacoes-login-documento-erro">
          Informe um CPF ou CNPJ válido.
        </p>
      }

      <label class="informacoes-login-rotulo" for="informacoes-login-senha">Senha</label>
      <div class="informacoes-login-senha">
        <input
          id="informacoes-login-senha"
          class="informacoes-login-campo informacoes-login-campo-senha"
          [type]="senhaVisivel() ? 'text' : 'password'"
          autocomplete="current-password"
          placeholder="Digite sua senha"
          [attr.aria-invalid]="tentouEntrar() && !senhaValida()"
          [attr.aria-describedby]="tentouEntrar() && !senhaValida() ? 'informacoes-login-senha-erro' : null"
          [formField]="loginForm.senha"
        />
        <button
          type="button"
          class="informacoes-login-olho"
          [attr.aria-label]="senhaVisivel() ? 'Ocultar senha' : 'Mostrar senha'"
          [attr.aria-pressed]="senhaVisivel()"
          (click)="alternarSenha()"
        >
          <i-lucide [name]="senhaVisivel() ? 'eye-off' : 'eye'" size="18" aria-hidden="true"></i-lucide>
        </button>
      </div>
      @if (tentouEntrar() && !senhaValida()) {
        <p class="informacoes-login-erro-campo" id="informacoes-login-senha-erro">Senha é obrigatória.</p>
      }

      <p class="informacoes-login-atalhos">
        <a
          class="informacoes-login-link"
          href="https://sai3.io.org.br/Account/ForgotPassword"
          target="_blank"
          rel="noopener"
        >
          Esqueci a senha
        </a>
      </p>

      @if (erroLogin()) {
        <p class="informacoes-login-erro" role="alert" aria-live="assertive">{{ erroLogin() }}</p>
      }

      <button
        type="submit"
        class="informacoes-login-botao informacoes-login-botao-primario"
        [disabled]="entrando()"
      >
        <i-lucide name="log-in" size="16" aria-hidden="true"></i-lucide>
        {{ entrando() ? 'Entrando...' : 'Entrar com login' }}
      </button>
    </form>

    <a
      class="informacoes-login-botao informacoes-login-botao-govbr"
      href="#"
      (click)="$event.preventDefault(); acessarGov.emit()"
    >
      <i-lucide name="globe" size="18" aria-hidden="true"></i-lucide>
      <img
        class="informacoes-login-govbr-marca"
        ngSrc="assets/images/logo-gov.svg"
        width="62"
        height="18"
        alt="gov.br"
      />
    </a>

    @switch (acessoAnonimo()) {
      @case ('permitido') {
        <button
          type="button"
          class="informacoes-login-botao informacoes-login-botao-anonimo"
          (click)="seguirAnonimo.emit()"
        >
          <i-lucide name="shield" size="16" aria-hidden="true"></i-lucide>
          Solicitar anonimamente
        </button>
      }
      @case ('carregando') {
        <button type="button" class="informacoes-login-botao informacoes-login-botao-anonimo" disabled>
          <i-lucide name="shield" size="16" aria-hidden="true"></i-lucide>
          Solicitar anonimamente
        </button>
      }
      @case ('informativo') {
        <p class="informacoes-login-aviso-anonimo" role="note">
          <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
          Este serviço é apenas informativo.
        </p>
      }
      @case ('identificacao') {
        <p class="informacoes-login-aviso-anonimo" role="note">
          <i-lucide name="user-check" size="16" aria-hidden="true"></i-lucide>
          Este serviço exige identificação do cidadão.
        </p>
      }
      @default {
        <p class="informacoes-login-aviso-anonimo" role="note">
          <i-lucide name="info" size="16" aria-hidden="true"></i-lucide>
          A solicitação on-line deste serviço não está disponível.
        </p>
      }
    }
    }
  </aside>
</div>
